import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Location } from '@angular/common';

import { FileManagerPluginService } from './filemanager-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';
import { FileManagerMenuComponent } from '../../menus/index';
import * as _ from 'lodash';
import { FileReaderComponent } from '../../modal/file-reader.component';
import { NodeItem } from '../../file-manager/models/node.model';
import { ContentType } from '../../utils/enums/contentType.enum';
import { CreateFolderComponent } from './create-folder.component';

@Component({
    selector: 'filemanager-edit',
    templateUrl: './filemanager-edit.component.html',
    standalone: false
})
export class FileManagerEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  public plugin: any;
  public fileBox: any;
  public nodes: NodeItem[];
  public processing = false;
  private openedAsset: NodeItem;
  private openedFolder: NodeItem;
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('createFolderModal', { static: true })
  createFolderModal: ModalComponent;
  @ViewChild('createFileBox', { static: true })
  createFileBox: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;
  @ViewChild('deleteFileBoxConfirm', { static: true })
  deleteFileBoxConfirm: ConfirmComponent;
  @ViewChild('filePreview', { static: true })
  filePreview: FileReaderComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: FileManagerPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) {
        this.goToBack();
      }

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) {
        this.goToBack();
      }

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) {
        this.goToBack();
      }

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service.updateFileManager(this.inspectionId, this.pointId, this.pluginId, model.value).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.service.getFileBox(this.plugin.config.FileBoxId).subscribe((fileBox: any) => {
        this.fileBox = fileBox;
        this.nodes = this.initNodes([fileBox]);
        this.cdRef.detectChanges();
      });
    });
  }

  private initNodes(fileBoxes: any[], parent?: NodeItem) {
    const nodes: NodeItem[] = [];
    fileBoxes.forEach((f) => {
      const node = this.initNode(f, parent);
      nodes.push(node);
    });
    return nodes;
  }

  private initNode(fileBox: any, parent?): NodeItem {
    const node: NodeItem = Object.assign(new NodeItem(), fileBox);
    node.date = fileBox.dateOfCreation || fileBox.etag;
    node.fileNode = true;
    if (fileBox.items) {
      node.children = this.initNodes(fileBox.items, node);
      node.fileNode = false;
    }
    node.parent = parent;
    node.data = fileBox;
    return node;
  }

  public openMenu(): void {
    this.menuModal.modalFooter = false;
    this.menuModal.modalHeader = false;
    this.menuModal.modalMessage = false;
    this.menuModal.open(FileManagerMenuComponent, { fileBox: this.fileBox, plugin: this.plugin });
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 2:
        this.openCreateFileBox();
        break;
      case 3:
        this.openDeleteFileBox();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  openCreateFileBox() {
    this.createFileBox.open(CreateFolderComponent);
  }

  openDeleteFileBox() {
    this.deleteFileBoxConfirm.open();
  }

  createNewFileBox(name: string) {
    this.service.createFileBox({ name }).subscribe((fileBox) => {
      this.service.updateFileManager(this.inspectionId, this.pointId, this.pluginId, fileBox.id).subscribe(() => {
        this.nodes = null;
        this.openedAsset = null;
        this.openedFolder = null;
        this.fileBox = fileBox;
        this.nodes = this.initNodes([fileBox]);
      });
    });
  }

  deleteFileBox() {
    this.service.deleteFileBox(this.fileBox.id).subscribe(() => {
      this.nodes = null;
      this.openedAsset = null;
      this.openedFolder = null;
      this.fileBox = null;
      this.service.updateFileManager(this.inspectionId, this.pointId, this.pluginId, null).subscribe(() => {});
    });
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin() {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }

  openAsset(node: NodeItem) {
    this.filePreview.fileBox = node.data;
    this.filePreview.title = node.name;
    if (node.mimeType.includes('image')) {
      this.filePreview.contentType = ContentType.image;
    }
    if (node.mimeType.includes('pdf')) {
      this.filePreview.contentType = ContentType.pdf;
    }
    this.filePreview.open();
    this.openedAsset = node;
  }

  openFolder(node: NodeItem) {
    this.openedFolder = node;
  }

  selectFileBox(fileBox: any) {
    if (this.openedAsset && this.openedAsset.data.id === fileBox.id) {
      this.openedAsset.selected = true;
    }
  }

  openCreateFolder() {
    this.createFolderModal.open(CreateFolderComponent);
  }

  createFolder(name: string) {
    if (this.openedFolder.opened) {
      this.service
        .createFolder({ name, parentFileBox: this.openedFolder.data.id, rootFileBox: this.fileBox.id })
        .subscribe((fileBox) => {
          const node = this.initNode(fileBox, this.openedFolder);
          this.openedFolder.children.push(node);
        });
    }
  }

  uploadFiles(files: any[]) {
    const inputFile = new FormData();
    for (let i = 0; i < files.length; i++) {
      inputFile.append(`files[${i}]`, files[i], files[i].name);
    }
    this.service.uploadFiles(this.fileBox.id, this.openedFolder.data.id, inputFile).subscribe((fileBoxes) => {
      const nodes = this.initNodes(fileBoxes);
      this.openedFolder.children.push(...nodes);
    });
  }

  deleteItems(nodes: NodeItem[]) {
    const fileBoxes = nodes.map((n) => n.data.id);
    this.service
      .deleteItems({ fileBoxes, parentFileBox: this.openedFolder.data.id, rootFileBox: this.fileBox.id })
      .subscribe(() => {
        this.openedFolder.children = this.openedFolder.children.filter((n) => !nodes.includes(n));
      });
  }
}
